/**
 * All Categories. Just need to cover images
 */
(function ($) {
	let allCategories = ".wp-block-uniek-all-categories";
	let categoryContainer = ".category > .container";
	let activeClass = "is-activated";

	let $allCategories = $(allCategories);

	function scaleBanners() {
		$allCategories.each(function () {
			let $block = $(this);
			let $categories = $block.find(categoryContainer);
			$categories.each(function () {
				let $container = $(this);
				let $image = $container.find("img");
				scaleImageContainer($container, $image);
			});
		});
	}

	$(document).ready(function () {
		$allCategories.each(function () {
			let $categories = $(this).find(categoryContainer);
			$categories.each(function () {
				let $container = $(this);
				let $brands = $container.find(".brand");
				$brands.on({
					focus: function () {
						$container.addClass(activeClass);
					},
					blur: function () {
						$container.removeClass(activeClass);
					},
				});
			});
		});
	});

	$(window).on("load resize", function () {
		scaleBanners();
	});
})(jQuery);
